import { put, get, post, del, createQueryParams } from "./axiosComponent.js";
import { serverData, serviceUrls } from "./constant.js";

export const getPlanList = async (data) => {
  return await get({
    url: serviceUrls.LICENSE_SERVICE + "/default/organization/plan/list",
    params: createQueryParams(data),
  });
};
export const getSystemServices = async (data) => {
  return await get({
    url: serviceUrls.LICENSE_SERVICE + "/default/system/services/list",
    params: createQueryParams(data),
  });
};

export const customUserPlan = async (data) => {
  return await get({
    url: serviceUrls.LICENSE_SERVICE + "/default/organization/user/discount/list",
    params: createQueryParams(data),
  });
};

export const createPlan = async (data) => {
  return await post({
    url: serviceUrls.LICENSE_SERVICE + "/default/organization/plan",
    data,
  });
};
export const suscribe = async (data) => {
  return await post({
    url: serviceUrls.ADMIN_SERVICE + "/default/onboard/subscribe",
    data,
  });
};
